module.exports = __webpack_public_path__ + "img/File_Filled_16px_Icon.855dc34f.svg";